import Study from './Study';
export default Study;
